export class API_URLS {
  // public static  BASE_URL:string = "http://localhost:44301";
  // public static BASE_URL: string = 'http://52.233.75.131:8086';
  // public static BASE_URL: string = "http://apieport.gcps.edu.gh";
  // public static  BASE_URL:string = "http://eportapi.gcps.nantisys.com";


  // public static BASE_URL: string = 'http://localhost:32014'; //<--- CURRENT DEV URL

  public static BASE_URL: string = "https://eportapi.nantisys.com"; //<--- CURRENT LIVE URL

  public static API_GET_FACULTIES: string =
    API_URLS.BASE_URL + "/api/v1/Faculty/GetAll";
  // public static API_GET_YEAR_GROUPS:string =API_URLS.BASE_URL+"/api/AcademicYears/GetYearGroups" ;
  public static API_GET_LOGBOOK_FACULTIES: string =
    API_URLS.BASE_URL + "/api/v1/Faculty/LogBookFaculties";
  public static API_ADD_FACULTY: string =
    API_URLS.BASE_URL + "/api/v1/Faculty/Add";
  public static API_EDIT_FACULTY: string =
    API_URLS.BASE_URL + "/api/v1/Faculty/Update";
  public static API_REMOVE_FACULTY: string =
    API_URLS.BASE_URL + "/api/v1/Faculty/Remove";
  static API_GET_FACULTY_TRAINEES_MEDICAL_PROCEDURE_CASES: string =
    API_URLS.BASE_URL +
    "/api/v1/Faculty/GetFacultyStudentMedicalProcedureCases";

  public static API_GET_HOSPITALS: string =
    API_URLS.BASE_URL + "/api/v1/Hospital/GetAll";
  public static API_GET_HOSPITAL: string =
    API_URLS.BASE_URL + "/api/v1/Hospital/GetHospital";

  public static API_GET_BY_FACULTY_MEDICAL_PROCEDURE: string =
    API_URLS.BASE_URL + "/api/v1/Hospital/GetByFacultyMedicalProcedure";
  public static API_ADD_HOSPITAL: string =
    API_URLS.BASE_URL + "/api/v1/Hospital/Add";
  public static API_EDIT_HOSPITAL: string =
    API_URLS.BASE_URL + "/api/v1/Hospital/Update";

  public static API_REMOVE_HOSPITAL: string =
    API_URLS.BASE_URL + "/api/v1/Hospital/Remove";

  public static API_GET_FELLOWSHIP_SPECIALISATIONS: string =
    API_URLS.BASE_URL + "/api/v1/FellowshipSpecialisation/GetAll";
  public static API_ADD_FELLOWSHIP_SPECIALISATION: string =
    API_URLS.BASE_URL + "/api/v1/FellowshipSpecialisation/Add";
  public static API_EDIT_FELLOWSHIP_SPECIALISATION: string =
    API_URLS.BASE_URL + "/api/v1/FellowshipSpecialisation/Update";
  public static API_REMOVE_FELLOWSHIP_SPECIALISATION: string =
    API_URLS.BASE_URL + "/api/v1/FellowshipSpecialisation/Remove";

  public static API_GET_MEDICAL_PROCEDURE_PERFORMANCE_TYPES: string =
    API_URLS.BASE_URL +
    "/api/v1/FacultyMedicalProcedure/GetProcedurePerformanceTypes";
  public static API_GET_FACULTY_MEDICAL_PROCEDURE_CATEGORIES: string =
    API_URLS.BASE_URL + "/api/v1/FacultyMedicalProcedureCategory/GetAll";
  public static API_ADD_FACULTY_MEDICAL_PROCEDURE_CATEGORY: string =
    API_URLS.BASE_URL + "/api/v1/FacultyMedicalProcedureCategory/Add";
  public static API_GET_FACULTY_MEDICAL_PROCEDURE: string =
    API_URLS.BASE_URL + "/api/v1/FacultyMedicalProcedure/Get";
  public static API_EDIT_FACULTY_MEDICAL_PROCEDURE_CATEGORY: string =
    API_URLS.BASE_URL + "/api/v1/FacultyMedicalProcedureCategory/Update";
  public static API_REMOVE_FACULTY_MEDICAL_PROCEDURE_CATEGORY: string =
    API_URLS.BASE_URL + "/api/v1/FacultyMedicalProcedureCategory/Remove";

  public static API_GET_FACULTY_MEDICAL_PROCEDURES: string =
    API_URLS.BASE_URL + "/api/v1/FacultyMedicalProcedure/GetAll";
  public static API_ADD_FACULTY_MEDICAL_PROCEDURE: string =
    API_URLS.BASE_URL + "/api/v1/FacultyMedicalProcedure/Add";
  public static API_EDIT_FACULTY_MEDICAL_PROCEDURE: string =
    API_URLS.BASE_URL + "/api/v1/FacultyMedicalProcedure/Update";
  public static API_REMOVE_FACULTY_MEDICAL_PROCEDURE: string =
    API_URLS.BASE_URL + "/api/v1/FacultyMedicalProcedure/Remove";

  public static API_REMOVE_FACULTY_MEDICAL_PROCEDURE_HOSPITAL: string =
    API_URLS.BASE_URL + "/api/v1/FacultyMedicalProcedure/RemoveHospital";
  public static API_ADD_FACULTY_MEDICAL_PROCEDURE_HOSPITAL: string =
    API_URLS.BASE_URL + "/api/v1/FacultyMedicalProcedure/AddHospital";
  public static API_TRAINEE_BULK_UPLOAD: string =
    API_URLS.BASE_URL + "/api/Account/UploadBulkResidents";

  public static API_GET_FACULTY_MEDICAL_PROCEDURE_PARAMETERS: string =
    API_URLS.BASE_URL + "/api/v1/FacultyMedicalProcedureParameter/GetAll";
  public static API_ADD_FACULTY_MEDICAL_PROCEDURE_PARAMETER: string =
    API_URLS.BASE_URL + "/api/v1/FacultyMedicalProcedureParameter/Add";
  public static API_EDIT_FACULTY_MEDICAL_PROCEDURE_PARAMETER: string =
    API_URLS.BASE_URL + "/api/v1/FacultyMedicalProcedureParameter/Update";
  public static API_REMOVE_FACULTY_MEDICAL_PROCEDURE_PARAMETER: string =
    API_URLS.BASE_URL + "/api/v1/FacultyMedicalProcedureParameter/Remove";

  public static API_GET_FACULTY_MEDICAL_PROCEDURE_PARAMETERS_FOR_NEW_CASE: string =
    API_URLS.BASE_URL +
    "/api/v1/FacultyMedicalProcedureParameter/GetFacultyMedicalProcedureParametersForNewCase";

  public static API_GET_FACULTY_FELLOWSHIP_SPECIALISATIONS: string =
    API_URLS.BASE_URL + "/api/v1/FacultyFellowshipSpecialisation/GetAll";
  public static API_ADD_FACULTY_FELLOWSHIP_SPECIALISATION: string =
    API_URLS.BASE_URL + "/api/v1/FacultyFellowshipSpecialisation/Add";
  public static API_EDIT_FACULTY_FELLOWSHIP_SPECIALISATION: string =
    API_URLS.BASE_URL + "/api/v1/FacultyFellowshipSpecialisation/Update";
  public static API_REMOVE_FACULTY_FELLOWSHIP_SPECIALISATION: string =
    API_URLS.BASE_URL + "/api/v1/FacultyFellowshipSpecialisation/Remove";
  public static API_PROGRAM_CATEGORIES: string =
    API_URLS.BASE_URL + "/api/ProgramCategories";

  public static API_GET_STATS_DASHBOARD_HEADER_STATS: string =
    API_URLS.BASE_URL + "/api/v1/Stats/GetDashboarHeaderStats";
  public static API_GET_STATS_TOP_TEN_TRAINEES: string =
    API_URLS.BASE_URL + "/api/v1/Stats/GetTopTenTrainees";
  public static API_GET_STATS_TOP_TEN_TRAINERS: string =
    API_URLS.BASE_URL + "/api/v1/Stats/GetTopTenTrainers";
  public static API_GET_STATS_HOSPITAL_ACTIVITIES: string =
    API_URLS.BASE_URL + "/api/v1/Stats/GetHospitalActivities";
  public static API_GET_STATS_PROCEDURE_MONTHLY_BY_TRAINEE: string =
    API_URLS.BASE_URL + "/api/v1/Stats/GetProcedureMonthlyTrendByTrainee";
  public static API_GET_STATS_PROCEDURE_MONTHLY_BY_FACULTY: string =
    API_URLS.BASE_URL + "/api/v1/Stats/GetProcedureMonthlyTrendByFaculty";
  static API_GET_FACULTY_STUDENTS_PROCEDURE_SUMMARY: string =
    API_URLS.BASE_URL +
    "/api/v1/Stats/GetFacultyStudentMedicalProcedureForPeriod";
  public static API_GET_STATS_RECENT_MEDICAL_PROCEDURE_CASES: string =
    API_URLS.BASE_URL + "/api/v1/Stats/GetFacultyRecentMedicalProcedureCases";

  public static API_GET_HAS_USER_ACCESS_RIGHT_TO_APP_MODULE: string =
    API_URLS.BASE_URL + "/api/Account/GetHasUserAccessRightToAppModule";

  public static API_ADD_USER_ROLE_APP_MODULE: string =
    API_URLS.BASE_URL + "/api/Account/AddUserRoleModule";
  public static API_REMOVE_USER_ROLE_APP_MODULE: string =
    API_URLS.BASE_URL + "/api/Account/RemoveUserRoleModule";
  public static API_GET_USER_ROLE_APP_MODULES: string =
    API_URLS.BASE_URL + "/api/Account/GetRoleAppModules";
  public static API_GET_ROLES: string =
    API_URLS.BASE_URL + "/api/Account/GetRoles";
  public static API_ADD_ROLE: string =
    API_URLS.BASE_URL + "/api/Account/AddRole";
  public static API_GET_USER_ROLES: string =
    API_URLS.BASE_URL + "/api/Account/GetUserRoles";
  public static API_GET_USER_DETAIL: string =
    API_URLS.BASE_URL + "/api/Account/GetUserDetail";
  public static API_UPDATE_USER_ROLES: string =
    API_URLS.BASE_URL + "/api/Account/user";

  public static API_VERIFY_USER_PHONE: string =
    API_URLS.BASE_URL + "/api/Account/VerifyUserPhoneNumber";

  public static API_RESET_USER_PASSWORD_WITH_SMS: string =
    API_URLS.BASE_URL + "/api/Account/ResetUserPasswordWithSmsCode";

  public static API_SEND_VERIFY_CODE: string =
    API_URLS.BASE_URL + "/api/Account/SendVerifyCode";
  public static API_VERIFY_SMS_CODE: string =
    API_URLS.BASE_URL + "/api/Account/VerifySMSCode";

  public static API_GET_TRAINEES: string =
    API_URLS.BASE_URL + "/api/Account/GetTrainees";

  public static API_GET_TRAINEES_BY_FACULTY: string =
    API_URLS.BASE_URL + "/api/Account/GetTraineesByFaculty";
  public static API_GET_TRAINEES_BY_SCHEDULED_ROTATION_HOSPITAL: string =
    API_URLS.BASE_URL + "/api/Account/GetTraineesBySheduleRotationHospital";
  public static API_GET_TRAINEES_BY_POSTING_HOSPITAL: string =
    API_URLS.BASE_URL + "/api/Account/GetTraineesByPostingHospital";

  public static API_GET_TRAINERS: string =
    API_URLS.BASE_URL + "/api/Account/GetTrainers";
  public static API_GET_ALL_TRAINERS: string =
    API_URLS.BASE_URL + "/api/Account/GetAllTrainers";

  public static API_GET_SYSTEM_USERS: string =
    API_URLS.BASE_URL + "/api/Account/GetSystemUsers";

  public static API_ADD_USER_TRAINER: string =
    API_URLS.BASE_URL + "/api/Account/AddTrainer";
  public static API_ADD_USER_TRAINEE: string =
    API_URLS.BASE_URL + "/api/Account/AddTrainee";
  public static API_ADD_USER_SYSTEM_USER: string =
    API_URLS.BASE_URL + "/api/Account/RegisterUser";

    public static API_ADD_BULK_TRAINEE: string =
    API_URLS.BASE_URL + "/api/Account/BulkRegisterUser";

  public static API_GET_USER_BY_USERNAME: string =
    API_URLS.BASE_URL + "/api/Account/FindUserByUserName";

  public static API_UPDATE_USER: string =
    API_URLS.BASE_URL + "/api/Account/UpdateUser";
  public static API_UPDATE_USER_TRAINER: string =
    API_URLS.BASE_URL + "/api/Account/UpdateTrainer";

  public static API_GET_YEAR_GROUPS: string =
    API_URLS.BASE_URL + "/api/Account/GetYearGroups";
  public static API_GET_APP_MODULES: string =
    API_URLS.BASE_URL + "/api/Account/GetAppModules";
  public static API_GET_USER_APP_MODULES: string =
    API_URLS.BASE_URL + "/api/Account/GetUserAppModules";

  public static API_LOGIN_PASSWORD: string =
    API_URLS.BASE_URL + "/api/v1/Auth/Login";

  public static API_GET_TRAINEE_MEDICAL_PROCEDURE_CASES: string =
    API_URLS.BASE_URL + "/api/v1/Student/GetStudentMedicalProcedureCases";

  public static API_GET_MEDICAL_PROCEDURE_CASES_REPORT: string =
    API_URLS.BASE_URL +
    "/api/v1/Student/GetMedicalProcedureCasesDateRangeReport";

  public static API_GET_TRAINEE_MEDICAL_PROCEDURE_CASE_ITEM: string =
    API_URLS.BASE_URL + "/api/v1/Student/GetStudentMedicalProcedureCaseItem";

  public static API_GET_TRAINEER_TRAINEES_WITH_PENDING_ROTATIONS: string =
    API_URLS.BASE_URL +
    "/api/v1/StudentRotation/GetSupervisorStudentsWithPendingRotations";
  public static API_GET_TRAINEE_ROTATIONS_REPORT: string =
    API_URLS.BASE_URL + "/api/v1/StudentRotation/GetRotationsDateRangeReport";
  public static API_GET_TRAINEER_TRAINEES_WITH_PENDING_ASSESSMENTS: string =
    API_URLS.BASE_URL +
    "/api/v1/ContinousAssessment/GetSupervisorStudentsWithPendingAssessments";
  public static API_GET_SUPERVISOR_ASSESSMENTS_BY_STUDENT =
    API_URLS.BASE_URL +
    "/api/v1/ContinousAssessment/GetAssessmentsOfSupervisorByStudent";
  public static API_GET_SUPERVISOR_STUDENTS_AT_HOSPITAL_FACULTY =
    API_URLS.BASE_URL +
    "/api/v1/Supervisor/GetSupervisorStudentsAtHospitalFaculty";
  public static API_GET_GET_PENDING_ROTATION =
    API_URLS.BASE_URL +
    "/api/v1/Supervisor/GetSupervisorStudentsAtHospitalFaculty";
  public static API_GET_SUGGESTED_TRAINERS_BY_STATUS =
    API_URLS.BASE_URL + "/api/Account/GetUserSuggestedTrainersByStatus";
  public static API_POST_TAKE_SUGGESTED_USER_ACTION =
    API_URLS.BASE_URL + "/api/Account/TakeSuggestedTrainerAction";

  public static API_GET_STUDENT_MEDICAL_PROCEDURES: string =
    API_URLS.BASE_URL + "/api/v1/Student/GetStudentFacultyMedicalProcedures";
  public static API_GET_STUDENT_MEDICAL_PROCEDURES_BY_FELLOWSHIP_SPECIALISATION: string =
    API_URLS.BASE_URL +
    "/api/v1/Student/GetStudentFacultyMedicalProcedureByFellowshipSpecialisation";

  public static API_GET_TRAINEE_MEDICAL_PROCEDURE_CASE_PARAMETERS: string =
    API_URLS.BASE_URL +
    "/api/v1/Student/GetStudentMedicalProcedureCaseParameters";
  public static API_GET_TRAINEE_MEDICAL_PROCEDURE_CASE_ATTACHMENTS: string =
    API_URLS.BASE_URL +
    "/api/v1/Student/GetStudentMedicalProcedureCaseAttachments";
  public static API_ADD_TRAINEE_MEDICAL_PROCEDURE_CASE_ATTACHMENTS: string =
    API_URLS.BASE_URL +
    "/api/v1/Student/AddStudentMedicalProcedureCaseAttachment";
  public static API_GET_TRAINEE_MEDICAL_PROCEDURE_CASE_REVIEWS: string =
    API_URLS.BASE_URL + "/api/v1/Student/GetStudentMedicalProcedureCaseReviews";
  public static API_GET_TRAINEE_MEDICAL_PROCEDURE_ACTIVITY_DETAILS: string =
    API_URLS.BASE_URL + "/api/v1/Student/GetStudentMedicalProcedureCaseByRef";
  public static API_GET_FACULTY_MEDICAL_PROCEDURE_REVIEW_PARAMETERS: string =
    API_URLS.BASE_URL +
    "/api/v1/FacultyMedicalProcedureCaseReviewParameter/GetAll";
  public static API_ADD_FACULTY_MEDICAL_PROCEDURE_REVIEW_PARAMETER: string =
    API_URLS.BASE_URL +
    "/api/v1/FacultyMedicalProcedureCaseReviewParameter/Add";
  public static API_EDIT_FACULTY_MEDICAL_PROCEDURE_REVIEW_PARAMETER: string =
    API_URLS.BASE_URL +
    "/api/v1/FacultyMedicalProcedureCaseReviewParameter/Update";
  public static API_REMOVE_FACULTY_MEDICAL_PROCEDURE_REVIEW_PARAMETER: string =
    API_URLS.BASE_URL +
    "/api/v1/FacultyMedicalProcedureCaseReviewParameter/Remove";

  public static API_POST_ADD_TRAINEE_MEDICAL_PROCEDURE_CASE: string =
    API_URLS.BASE_URL + "/api/v1/Student/CreateStudentMedicalProcedureCase";
  public static API_POST_UPDATE_TRAINEE_MEDICAL_PROCEDURE_CASE: string =
    API_URLS.BASE_URL +
    "/api/v1/Student/UpdateStudentMedicalProcedureCaseParameters";
  public static API_POST_ADD_TRAINEE_MEDICAL_PROCEDURE_CASE_REVIEW: string =
    API_URLS.BASE_URL + "/api/v1/Student/CreateStudentMedicalProcedureCase";
  public static API_POST_ADD_TRAINEE_MEDICAL_PROCEDURE_CASE_ATTACHMENT: string =
    API_URLS.BASE_URL + "/api/v1/Student/CreateStudentMedicalProcedureCase";

  public static API_GET_FACULTY_MEDICAL_PROCEDURE_CASE_REVIEW_PARAMETERS_FOR_NEW_REVIEW: string =
    API_URLS.BASE_URL +
    "/api/v1/FacultyMedicalProcedureCaseReviewParameter/GetFacultyMedicalProcedureCaseReviewParametersForNewReview";

  public static API_REMOVE_TRAINEE_MEDICAL_PROCEDURE_CASE_REVIEW: string =
    API_URLS.BASE_URL +
    "api/v1/Student/DeleteStudentMedicalProcedureCaseReview";
  public static API_REMOVE_TRAINEE_MEDICAL_PROCEDURE_CASE_ATTACHMENT: string =
    API_URLS.BASE_URL +
    "/api/v1/Student/DeleteStudentMedicalProcedureCaseAttachment";

  public static API_POST_START_TRAINEE_MEDICAL_PROCEDURE: string =
    API_URLS.BASE_URL + "/api/v1/Student/StartNewMedicalProcedure";
  public static API_POST_APPROVE_TRAINEE_MEDICAL_PROCEDURE_CASE: string =
    API_URLS.BASE_URL + "/api/v1/Supervisor/ApproveMedicalProcedureCase";
  public static API_POST_APPROVE_CONTINUOUS_ASSESSMENT: string =
    API_URLS.BASE_URL +
    "/api/v1/ContinousAssessment/ApproveContinuousAssessment";
  public static API_GET_STUDENT_CONTINUOUS_ASSESSMENT_REPORT: string =
    API_URLS.BASE_URL +
    "/api/v1/ContinousAssessment/GetStudentAssessmentDateRangeReport";
  public static API_POST_APPROVE_TRAINER_TRAINEE_ALL_MEDICAL_PROCEDURE_CASE: string =
    API_URLS.BASE_URL +
    "/api/v1/Supervisor/SupervisorApproveAllStudentProcedures";
  public static API_POST_APPROVE_TRAINER_TRAINEE_ALL_ROTATIONS: string =
    API_URLS.BASE_URL +
    "/api/v1/Supervisor/SupervisorApproveAllStudentRotations";

  public static API_GET_TRAINEE_LOGBOOK_AUDIT: string =
    API_URLS.BASE_URL + "/api/v1/Student/GetStudentLogbookAudit";
  public static API_GET_TRAINER_LOGBOOK_AUDIT: string =
    API_URLS.BASE_URL + "/api/v1/Supervisor/GetSupervisorLogbookAudit";

  public static API_GET_TRAINEE_OVERVIEW: string =
    API_URLS.BASE_URL + "/api/v1/Student/GetStudentOverview";
  public static API_GET_TRAINER_OVERVIEW: string =
    API_URLS.BASE_URL + "/api/v1/Supervisor/GetSupervisorOverview";

  public static API_GET_TRAINEE_ROTATIONS: string =
    API_URLS.BASE_URL + "/api/v1/StudentRotation/GetAll";

  public static API_GET_ALL_TRAINEE_ROTATIONS: string =
    API_URLS.BASE_URL + "/api/v1/StudentRotation";

  public static API_GET_TRAINEE_ROTATION_BY_REF: string =
    API_URLS.BASE_URL + "/api/v1/StudentRotation/GetRotationByRef";

  public static API_GET_TRAINEE_ROTATION_DETAILS: string =
    API_URLS.BASE_URL + "/api/v1/StudentRotation/GetStudentRotationByStudent";

  public static API_GET_TRAINEE_ROTATION_SCHEDULE_ROTATIONS =
    API_URLS.BASE_URL + "/api/v1/StudentRotation/GetRotationScheduleRotations";
  public static API_GET_TRAINEE_ACTIVE_ROTATIONS: string =
    API_URLS.BASE_URL + "/api/v1/StudentRotation/GetActive";

  public static API_GET_TRAINER_TRAINEE_ROTATIONS: string =
    API_URLS.BASE_URL + "/api/v1/StudentRotation/GetBySupervisorStudent";

  public static API_GET_TRAINER_TRAINEE_MEDICAL_PROCEDURE_CASES: string =
    API_URLS.BASE_URL + "/api/v1/Student/GetProceduresBySupervisorStudent";

  public static API_POST_ADD_TRAINEE_ROTATIONS: string =
    API_URLS.BASE_URL + "/api/v1/StudentRotation/Add";
  public static API_POST_EDIT_TRAINEE_ROTATIONS: string =
    API_URLS.BASE_URL + "/api/v1/StudentRotation/Update";
  public static API_POST_REMOVE_TRAINEE_ROTATIONS: string =
    API_URLS.BASE_URL + "/api/v1/StudentRotation/Remove";
  public static API_GET_ROTATION_TYPES =
    API_URLS.BASE_URL + "/api/v1/StudentRotation/GetRotationTypes";

  public static API_POST_ADD_TRAINER_HOSPITAL: string =
    API_URLS.BASE_URL + "/api/v1/Hospital/AddSupervisorHospital";
  public static API_GET_REMOVE_TRAINER_HOSPITAL: string =
    API_URLS.BASE_URL + "/api/v1/Hospital/RemoveSupervisorHospital";
  public static API_GET_TRAINER_HOSPITALS: string =
    API_URLS.BASE_URL + "/api/v1/Hospital/GetSupervisorHospital";
    public static API_GET_HOSPITAL_TRAINERS: string =
    API_URLS.BASE_URL + "/api/v1/Hospital/GetSupervisorsByHospital";

  public static API_GET_FACULTY_ROTATION_TYPES =
    API_URLS.BASE_URL + "/api/v1/StudentRotation/GetFacultyRotations";

  public static API_GET_TRAINEE_ROTATION_SCHEDULES: string =
    API_URLS.BASE_URL +
    "/api/v1/StudentRotationSchedule/GetStudentRotationSchedules";
  public static API_UPDATE_TRAINEE_ROTATION_SCHEDULES: string =
    API_URLS.BASE_URL +
    "/api/v1/StudentRotationSchedule/UpdateStudentRotationSchedule";

  public static API_SMS_NOTIFY_SEND_STUDENT_LOGBOOK_PROCEDURE_PENDING_REMINDER: string =
    API_URLS.BASE_URL +
    "/api/v1/Student/SendStudentLogbookProcedurePendingReminder";

  public static API_SMS_NOTIFY_SEND_SUPERVISOR_LOGBOOK_PROCEDURE_PENDING_REMINDER: string =
    API_URLS.BASE_URL +
    "/api/v1/Supervisor/SendSupervisorLogbookProcedurePendingReminder";

  public static API_GET_TRAINER_MEDICAL_PROCEDURES: string =
    API_URLS.BASE_URL +
    "/api/v1/Supervisor/GetSupervisorFacultyMedicalProcedures";

  public static API_GET_TRAINER_TRAINEES: string =
    API_URLS.BASE_URL + "/api/v1/Supervisor/GetAllTrainerTraineeRequests";

  public static API_GET_TRAINER_MEDICAL_PROCEDURES_TRAINEES =
    API_URLS.BASE_URL +
    "/api/v1/Supervisor/GetSupervisorFacultyMedicalProcedureStudents";

  public static API_GET_TRAINEE_FACULTY_CONTINUOUS_ASSESSMENT_FORM_TYPES =
    API_URLS.BASE_URL +
    "/api/v1/ContinousAssessment/GetFacultyContinuousAssessmentFormTypes";

  public static API_GET_TRAINER_FACULTY_CONTINUOUS_ASSESSMENT_FORM_TYPES =
    API_URLS.BASE_URL +
    "/api/v1/ContinousAssessment/GetFacultyContinuousAssessmentFormTypeForTrainer";

  public static API_GET_FACULTY_CONTINUOUS_ASSESSMENT_FORM =
    API_URLS.BASE_URL + "/api/v1/ContinousAssessment/GetFacultyAssessmentForm";

  public static API_GET_FACULTY_CONTINUOUS_ASSESSMENT_FORM_SCORE_CHART =
    API_URLS.BASE_URL +
    "/api/v1/ContinousAssessment/GetFacultyContinuousAssessmentFormScoreChart";

  public static API_GET_FACULTY_CONTINUOUS_ASSESSMENT_FORM_SCORE_CHART_BY_REF =
    API_URLS.BASE_URL +
    "/api/v1/ContinousAssessment/GetFacultyContinuousAssessmentFormScoreChartByRef";

  public static API_GET_TRAINEE_CONTINUOUS_ASSESSMENT_FORM_DETAIL =
    API_URLS.BASE_URL +
    "/api/v1/ContinousAssessment/GetStudentAssessmentDetail";

  public static API_GET_STUDENT_CONTINUOUS_ASSESSMENTS =
    API_URLS.BASE_URL + "/api/v1/ContinousAssessment/GetStudentAssessments";

  public static API_GET_STUDENT_CONTINUOUS_ASSESSMENT_BY_REF =
    API_URLS.BASE_URL + "/api/v1/ContinousAssessment/GetStudentAssessmentByRef";

  public static API_GET_STUDENT_CONTINUOUS_ASSESSMENT_DETAILS_BY_REF =
    API_URLS.BASE_URL +
    "/api/v1/ContinousAssessment/GetStudentAssessmentDetailsByRef";

  public static API_GET_SUPERVISOR_STUDENT_CONTINUOUS_ASSESSMENTS =
    API_URLS.BASE_URL + "/api/v1/ContinousAssessment/GetBySupervisorStudent";

  public static API_GET_STUDENT_ACTIVITIES =
    API_URLS.BASE_URL + "/api/v1/Student/GetStudentActivities";
  public static API_GET_STUDENT_ACTIVITIES_REPORT =
    API_URLS.BASE_URL + "/api/v1/Student/GetStudentActivitiesDateRangeReport";

  public static API_GET_TRAINEE_BY_RESIDENT_ID =
    API_URLS.BASE_URL + "/api/v1/Student/GetTraineeByResidentId";

  public static API_GET_TRAINEE_BY_SEARCH_TERM =
    API_URLS.BASE_URL + "/api/v1/Student/GetTraineeBySearchTerm";
    
  public static API_GET_SUPERVISIOR_ACTIVITIES =
    API_URLS.BASE_URL + "/api/v1/Supervisor/GetSupervisorActivities";

  public static API_POST_ADD_CONTINUOUS_ASSESSMENT_GROUP =
    API_URLS.BASE_URL +
    "/api/v1/ContinousAssessment/AddFacultyContinuousAssessmentFormGroup";

  public static API_POST_ADD_CONTINUOUS_ASSESSMENT =
    API_URLS.BASE_URL +
    "/api/v1/ContinousAssessment/InitiateContinuousAssessment";

  public static API_POST_ADD_CONTINUOUS_ASSESSMENT_FORM_DETAIL =
    API_URLS.BASE_URL +
    "/api/v1/ContinousAssessment/AddStudentContinousAssessmentDetail";

  public static API_GET_CONTINUOUS_ASSESSMENT =
    API_URLS.BASE_URL +
    "/api/v1/ContinousAssessment/GetGroupContinuousAssessmentCriteria";

  public static API_GET_CONTINUOUS_ASSESSMENT_GROUP =
    API_URLS.BASE_URL +
    "/api/v1/ContinousAssessment/GetFacultyContinuousAssessmentFormGroups";

  public static API_POST_EDIT_CONTINUOUS_ASSESSMENT_GROUP =
    API_URLS.BASE_URL +
    "/api/v1/ContinousAssessment/EditFacultyContinuousAssessmentFormGroup";

  public static API_POST_ADD_CONTINUOUS_ASSESSMENT_CRITERIA =
    API_URLS.BASE_URL +
    "/api/v1/ContinousAssessment/AddFacultyContinuousAssessmentCriteria";

  public static API_POST_EDIT_CONTINUOUS_ASSESSMENT_CRITERIA =
    API_URLS.BASE_URL +
    "/api/v1/ContinousAssessment/EditFacultyContinuousAssessmentCriteria";

  //cpd

  public static API_UPDATE_STUDENT_CPD =
    API_URLS.BASE_URL +
    "/api/v1/ContinuingProfessionalDevelopment/UpdateStudentContinuingProfessionalDevelopment";
  public static API_CONTINUING_PROFESSIONAL_DEVELOPMENT =
    API_URLS.BASE_URL + "/api/v1/ContinuingProfessionalDevelopment";

  public static API_GET_TRAINEE_CONTINUING_PROFESSIONAL_DEVELOPMENT =
    API_URLS.BASE_URL + "/api/v1/ContinuingProfessionalDevelopment/GetAll";

  public static API_GET_TRAINEE_CONTINUING_PROFESSIONAL_DEVELOPMENT_BY_TYPE =
    API_URLS.BASE_URL +
    "/api/v1/ContinuingProfessionalDevelopment/GetStudentCPDByType";
  public static API_GET_TRAINEE_CONTINUING_PROFESSIONAL_DEVELOPMENT_BY_REF =
    API_URLS.BASE_URL +
    "/api/v1/ContinuingProfessionalDevelopment/GetStudentCPDByRef";
  public static API_GET_CDP_REPORT =
    API_URLS.BASE_URL +
    "/api/v1/ContinuingProfessionalDevelopment/GetCPDDateRangeReport";

  public static API_POST_ADD_TRAINEE_CONTINUING_PROFESSIONAL_DEVELOPMENT =
    API_URLS.BASE_URL +
    "/api/v1/ContinuingProfessionalDevelopment/AddStudentContinuingProfessionalDevelopment";

  public static API_FACULTY_MANDATORY_CPD =
    API_URLS.BASE_URL +
    "/api/FacultyMandatoryContinuingProfessionalDevelopments";
  public static API_CPD_TYPE =
    API_URLS.BASE_URL + "/api/ContinuingProfessionalDevelopmentTypes";
  public static API_GET_ALL_MANDATORY_CPDS: string =
    API_URLS.BASE_URL +
    "/api/FacultyMandatoryContinuingProfessionalDevelopments/GetMandatoryCPDs";
  //report

  public static API_REPORT_GET_TRAINEE_CPD_SUMMARY =
    API_URLS.BASE_URL + "/api/v1/Student/GetStudentCPDSummaryReport";
  public static API_REPORT_GET_TRAINEE_PROCEDURES_SUMMARY_BY_TRAINEE_ROLE =
    API_URLS.BASE_URL +
    "/api/v1/Student/GetStudentProceduresSummaryByTraineeRoleReport";

  static API_RESET_SYSTEM_USER_PASSWORD: string =
    API_URLS.BASE_URL + "/api/Account/UpdatePassword";

  public static API_HELP_TOPICS: string = API_URLS.BASE_URL + "/api/HelpTopics";
  public static API_FACULTY_ROTATION =
    API_URLS.BASE_URL + "/api/FacultyRotations";
  public static API_ACADEMIC_YEAR = API_URLS.BASE_URL + "/api/AcademicYears";

  public static API_UPLOAD_ATTACHMENT: string =
    API_URLS.BASE_URL + "/api/v1/Student/UploadAttachment";
}
